import { Alert, defineComponent, inferProps, Modal, type ReactiveComponent } from "vue-utils"
import BootstrapButton from "./BootstrapButton"
import FormButtons from "./FormButtons"

interface Props {
	messages: string[]
	confirm(): void
}

const FormMissingInfo: ReactiveComponent<Props> = (props) => {
	function handleSubmit(e: Event) {
		e.preventDefault()
		props.confirm()
	}

	return () => (
		<Modal
			zIndex={3}
			style={{ minWidth: "32rem" }}
			onCancel={(e) => {
				e.preventDefault()
				props.confirm()
			}}
		>
			<form onSubmit={handleSubmit}>
				<Alert title="Missing Information">
					{props.messages.length === 1 ? (
						props.messages[0]
					) : (
						<ul style={{ margin: 0 }}>
							{props.messages.map((msg, i) => (
								<li key={i}>{msg}</li>
							))}
						</ul>
					)}
				</Alert>
				<hr />
				<FormButtons>
					<BootstrapButton type="submit" color="secondary">
						Ok
					</BootstrapButton>
				</FormButtons>
			</form>
		</Modal>
	)
}

export default defineComponent(FormMissingInfo, inferProps<Props>())
